export function getCopro(id: number, filterValidatedByUser?: boolean | null, filterValidatedByAdmin?: boolean | null, sortField?: string | null, sortDirection?: string | null): string {
  return `/api/companies/${id.toString()}/copros?limit=10000${filterValidatedByUser ? `&filterValidatedByUser=${filterValidatedByUser}` : ''}${filterValidatedByAdmin ? `&filterValidatedByAdmin=${filterValidatedByAdmin}` : ''}${sortField ? `&sortField=${sortField}` : ''}${sortDirection ? `&sortDirection=${sortDirection}` : ''}`;
}

export function getAttribution(id: number): string {
  return `/api/companies/${id.toString()}/validated-copros/attributions`;
}
export function getCoproPerformance(id: number): string {
  return `/api/companies/${id.toString()}/dpes/stats/steps`;
}

export function getUsers(id: number, filterIncludeSubcontractors?: boolean, filterType?: number, excludeType?: number): string {
  let url = `/api/companies/${id.toString()}/fonctions?limit=10000`;

  if (filterIncludeSubcontractors) {
    url += '&filterIncludeSubcontractors=true';
  }

  if (filterType !== undefined) {
    url += `&filterType=${filterType}`;
  }

  if (excludeType !== undefined) {
    url += `&excludeType=${excludeType}`;
  }

  return url;
}

// FonctionTypeUserEnum.AGENT_COMMERCIAL = 14
const AGENT_COMMERCIAL_TYPE = 14;

export function getAgentsCommerciaux(id: number): string {
  return getUsers(id, false, AGENT_COMMERCIAL_TYPE);
}

export function getSalaries(id: number, filterIncludeSubcontractors?: boolean): string {
  // Get all users except agents commerciaux
  return getUsers(id, filterIncludeSubcontractors, undefined, AGENT_COMMERCIAL_TYPE);
}

export function setAttribution(id: number) {
  return `/api/copros/${id.toString()}/attributions`;
}
export function delAttribution(id: number) {
  return `/api/attributions/${id.toString()}`;
}

export function getBrandingReferentMappings(companyId: number): string {
  return `/api/companies/${companyId}/branding-referent-mappings`;
}

export function assignBrandingReferent(companyId: number, coproId: number): string {
  return `/api/companies/${companyId}/copros/${coproId}/branding-referent`;
}

export function removeBrandingReferent(companyId: number, coproId: number): string {
  return `/api/companies/${companyId}/copros/${coproId}/branding-referent`;
}

export function bulkAssignBrandingReferent(companyId: number): string {
  return `/api/companies/${companyId}/branding-referent-mappings`;
}

export function getBauxCommerciaux(id: number): string {
  return `/api/companies/${id.toString()}/baux/deadlines`;
}

export function getBauxCommerciauxAEcheance(id: number): string {
  return `/api/companies/${id.toString()}/baux/deadlines?months=6`;
}

export function getBauxFromCopro(id: number): string {
  return `/api/copros/${id.toString()}/baux`;
}

export function getBauxFromCoproAEcheance(id: number): string {
  return `/api/copros/${id.toString()}/baux?months=6`;
}

export function getBodacc(id: number): string {
  return `/api/companies/${id.toString()}/bodaccs`;
}

export function getBodaccHistory(SIRET: string): string {
  return `/api/bodaccs/${SIRET}/history`;
}

export function getCoproSoonExpired(id: number, months: number): string {
  return `/api/companies/${id}/validated-copros/expired/${months}`;
}

export function fetchNewDpes(id: number, dpeStep: string | null, month: string | null, filterType: string | null, page: number = 1, limit: number = 10, createdBefore?: string, createdAfter?: string, receivedAtAfter?: string, assignedCoprosOnly?: boolean): string {
  let url = `/api/companies/${id.toString()}/dpes?step=${page}&limit=${limit}`;
  
  if (dpeStep) {
    url += `&filterDPEStep=${dpeStep}`;
  }
  
  if (month) {
    if (filterType === 'etablissement') {
      url += `&filterMonthEstablishedAt=${month}`;
    } else {
      url += `&filterMonthCreatedAt=${month}`;
    }
  }
  
  if (createdBefore) {
    url += `&filterCreatedAtBefore=${createdBefore}`;
  }
  
  if (createdAfter) {
    url += `&filterCreatedAtAfter=${createdAfter}`;
  }

  if (receivedAtAfter) {
    url += `&filterReceivedAtAfter=${receivedAtAfter}`;
  }

  if (assignedCoprosOnly) {
    url += '&filterAssignedCoprosOnly=1';
  }
  
  return url;
}

export function getClientFollowUpNextActions(page: number, limit: number): string {
  return `/api/admin/client-follow-up/next-actions?step=${page}&limit=${limit}`;
}

export function getClientFollowUpCalendar(from: string, to: string, includeRecurring: boolean): string {
  return `/api/admin/client-follow-up/calendar?from=${from}&to=${to}${includeRecurring ? '&includeRecurring=1' : ''}`;
}

export function completeCompanyToolsTimelineEvent(id: number): string {
  return `/api/companies/${id}/tools-timeline/completed-events`;
}

export function updateCompanyToolsTimeline(id: number): string {
  return `/api/companies/${id}/tools-timeline`;
}

export function sendTimelineInvitations(id: number): string {
  return `/api/companies/${id}/tools-timeline/send-invitations`;
}

export function sendTimelineRowInvitation(id: number, rowKey: string): string {
  return `/api/companies/${id}/tools-timeline/rows/${rowKey}/send-invitation`;
}

export function getMyCompanyRoles(id: number): string {
  return `/api/companies/${id}/roles/me`;
}

export function getCoproTeamTransactions(coproId: number): string {
  return `/api/copros/${coproId}/team/transactions`;
}

export function getCoproTeamRentals(coproId: number): string {
  return `/api/copros/${coproId}/team/rentals`;
}

export function getCoproTeamWeeklyPlanning(coproId: number, weekDate?: string): string {
  let url = `/api/copros/${coproId}/team/weekly-planning`;
  if (weekDate) {
    url += `?weekDate=${encodeURIComponent(weekDate)}`;
  }
  return url;
}

export function getCompanyTeamTransactions(companyId: number): string {
  return `/api/companies/${companyId}/team/transactions`;
}

export function getCompanyTeamRentals(companyId: number): string {
  return `/api/companies/${companyId}/team/rentals`;
}

export function getCompanyTeamWeeklyPlanning(companyId: number, weekDate?: string): string {
  let url = `/api/companies/${companyId}/team/weekly-planning`;
  if (weekDate) {
    url += `?weekDate=${encodeURIComponent(weekDate)}`;
  }
  return url;
}

// Boitage windows & assignments
export function getCompanyBoitageWindows(companyId: number): string {
  return `/api/companies/${companyId}/boitage/windows`;
}

export function getCompanyBoitageAssignments(companyId: number, year: number, eventIndex: 1 | 2): string {
  return `/api/companies/${companyId}/boitage/assignments?year=${year}&event=${eventIndex}`;
}

export function postCompanyBoitageAssignmentsBulk(companyId: number): string {
  return `/api/companies/${companyId}/boitage/assignments/bulk`;
}

export function deleteCompanyBoitageAssignmentsBulk(companyId: number): string {
  return `/api/companies/${companyId}/boitage/assignments/bulk`;
}

export function patchCompanyBoitageWindow(companyId: number): string {
  return `/api/companies/${companyId}/boitage/assignments/window`;
}

export function patchCoproBoitageAllowed(coproId: number): string {
  return `/api/copros/${coproId}`;
}

// Boitage documents (per upcoming window: year + eventIndex + kind)
export type BoitageDocumentType = 'stop-pub' | 'sans-stop-pub';

export function postCompanyBoitageWindowDocument(
  companyId: number,
  year: number,
  eventIndex: 1 | 2,
  type: BoitageDocumentType,
): string {
  return `/api/companies/${companyId}/boitage/windows/${year}/${eventIndex}/document/${type}`;
}

export function getCompanyBoitageWindowDocument(
  companyId: number,
  year: number,
  eventIndex: 1 | 2,
  type: BoitageDocumentType,
): string {
  return `/api/companies/${companyId}/boitage/windows/${year}/${eventIndex}/document/${type}`;
}

// SCI mail windows (kind + templateKey per upcoming SCI date)
export function getCompanySciMailWindows(companyId: number): string {
  return `/api/companies/${companyId}/sci-mail/windows`;
}

// Référent campaign windows (templateKey per upcoming Référent campaign date)
export function getCompanyReferentCampaignWindows(companyId: number): string {
  return `/api/companies/${companyId}/referent-campaign/windows`;
}

// Référent campaign custom document (Modèle 5 — Personnalisé, one per campaign 1|2|3)
export type ReferentCampaignNumber = 1 | 2 | 3;

export function getCompanyReferentCampaignDocument(
  companyId: number,
  campaign: ReferentCampaignNumber,
): string {
  return `/api/companies/${companyId}/referent-campaign/document/${campaign}`;
}

export function postCompanyReferentCampaignDocument(
  companyId: number,
  campaign: ReferentCampaignNumber,
): string {
  return `/api/companies/${companyId}/referent-campaign/document/${campaign}`;
}

export function deleteCompanyReferentCampaignDocument(
  companyId: number,
  campaign: ReferentCampaignNumber,
): string {
  return `/api/companies/${companyId}/referent-campaign/document/${campaign}`;
}

// NAF Exclusions
export function getNafExclusions(companyId: number): string {
  return `/api/companies/${companyId}/naf-exclusions`;
}

export function addNafExclusion(companyId: number): string {
  return `/api/companies/${companyId}/naf-exclusions`;
}

export function removeNafExclusion(companyId: number, nafCode: string): string {
  return `/api/companies/${companyId}/naf-exclusions/${encodeURIComponent(nafCode)}`;
}

export function getNafCodesHierarchy(): string {
  return '/api/naf-codes';
}

export function getInsuranceExclusions(companyId: number, filterNafCode?: string): string {
  let url = `/api/companies/${companyId}/baux/insurance-exclusions`;
  if (filterNafCode) {
    url += `?filterNafCode=${encodeURIComponent(filterNafCode)}`;
  }
  return url;
}

export function getCompanyVigilancesStats(companyId: number): string {
  return `/api/companies/${companyId}/vigilances/stats`;
}
